import React from "react";
import { Styles } from "./styles";
import logo from "../../assets/images/logos/08.png";
const Footer = ({ backgroundColor = null }) => {
  return (
    <Styles backgroundColor={backgroundColor}>
      <div className="container main-container">
        <div className="logo-container">
          <img src={logo} alt="logo" />
        </div>
        <p className="text-center">
          إن مجلس قبائل الشركس ليس كيانًا تقليديًا، بل مؤسسة وطنية تحمل إرثًا
          كبيرًا، وتؤمن بأن سوريا الجديدة تُبنى بجميع أبنائها. وإن المكوّن
          الشركسي، بتاريخِه وكفاءاتِه وقيمِه، قادر على أن يكون شريكًا أساسيًا في
          صناعة مستقبل البلاد
        </p>
      </div>
      {/* <div className="container copyright-section">
جميع الحقوق محفوئز

      </div> */}
    </Styles>
  );
};

export default Footer;
